import { useEffect, useState } from "react";
import { getApiBaseUrl } from "@/lib/api-base";

const API = getApiBaseUrl();
const PUBLIC_INDEX = "/content/content_index.json";

let cachedIndex = null;

async function loadIndex() {
  if (cachedIndex) return cachedIndex;
  try {
    const res = await fetch(`${API}/content/index`);
    if (res.ok) {
      cachedIndex = await res.json();
      return cachedIndex;
    }
  } catch {
    /* fallback */
  }
  const res = await fetch(PUBLIC_INDEX);
  if (!res.ok) throw new Error("Content index unavailable");
  cachedIndex = await res.json();
  return cachedIndex;
}

export function useContentIndex() {
  const [index, setIndex] = useState(cachedIndex);
  const [loading, setLoading] = useState(!cachedIndex);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (cachedIndex) return;
    loadIndex()
      .then(setIndex)
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  const normalized = index
    ? {
        ...index,
        gitas: Array.isArray(index.gitas)
          ? index.gitas
          : index.gita_index?.gitas ??
            Object.values(index.gitas || {}).map((g) => ({
              id: g.id,
              title: g.title,
              source: g.source,
              chapter_count_declared: g.chapter_count_declared,
              chapter_count_loaded: g.chapter_count_loaded ?? g.chapters?.length,
              verse_count: g.verse_count,
              languages_supported: g.languages_supported,
            })),
        gita_index: index.gita_index ?? null,
        gurus: Array.isArray(index.gurus) ? index.gurus : Object.values(index.gurus || {}),
        asanas: Array.isArray(index.asanas) ? index.asanas : Object.values(index.asanas || {}),
      }
    : null;

  return { index: normalized, loading, error, reload: async () => {
    cachedIndex = null;
    const idx = await loadIndex();
    setIndex(idx);
    return idx;
  }};
}

export { loadIndex as fetchContentIndex };
